import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { CASE_SET_FILTERED_AND_SORTED_DATA } from './constants';

export function setFilteredAndSortedData(data) {
  return {
    type: CASE_SET_FILTERED_AND_SORTED_DATA,
    data,
  };
}

export function useFilteredAndSortedData() {
  const dispatch = useDispatch();

  const { filteredAndSortedData } = useSelector(
    (state) => ({
      filteredAndSortedData: state.case.filteredAndSortedData,
    }),
    shallowEqual,
  );
  const boundAction = useCallback(
    (...args) => {
      return dispatch(setFilteredAndSortedData(...args));
    },
    [dispatch],
  );

  return {
    setFilteredAndSortedData: boundAction,
    filteredAndSortedData: filteredAndSortedData,
  };
}
export function reducer(state, action) {
  switch (action.type) {
    case CASE_SET_FILTERED_AND_SORTED_DATA:
      return {
        ...state,
        filteredAndSortedData: action.data,
      };

    default:
      return state;
  }
}
